import script from "./CryptoIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./CryptoIndex.vue?vue&type=script&setup=true&lang=ts"

import "./CryptoIndex.vue?vue&type=style&index=0&id=4acf2dca&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acf2dca"]])

export default __exports__